/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_RemoveInputs */

const id_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus`)
};

const ms_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buang`)
};

const da_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fjern`)
};

const de_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const en_us2_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const es_es2_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar`)
};

const es_mx2_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar`)
};

const fil_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggalin`)
};

const fr_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer`)
};

const it_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi`)
};

const hu_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltávolítás`)
};

const nl_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

const no_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fjern`)
};

const pl_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń`)
};

const pt_br2_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const pt_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

const ro_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimină`)
};

const fi_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista`)
};

const sv_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta bort`)
};

const vi_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa`)
};

const tr_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaldır`)
};

const cs_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odebrat`)
};

const bg_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премахване`)
};

const ru_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить`)
};

const uk_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалити`)
};

const ar_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة`)
};

const hi_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाएँ`)
};

const th_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบ`)
};

const ja_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_cn2_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const zh_hant1_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const ko_components_comparison_remove = /** @type {(inputs: Components_Comparison_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Components_Comparison_RemoveInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_remove = /** @type {((inputs?: Components_Comparison_RemoveInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_RemoveInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_remove(inputs)
	if (locale === "ms") return ms_components_comparison_remove(inputs)
	if (locale === "da") return da_components_comparison_remove(inputs)
	if (locale === "de") return de_components_comparison_remove(inputs)
	if (locale === "en-US") return en_us2_components_comparison_remove(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_remove(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_remove(inputs)
	if (locale === "fil") return fil_components_comparison_remove(inputs)
	if (locale === "fr") return fr_components_comparison_remove(inputs)
	if (locale === "it") return it_components_comparison_remove(inputs)
	if (locale === "hu") return hu_components_comparison_remove(inputs)
	if (locale === "nl") return nl_components_comparison_remove(inputs)
	if (locale === "no") return no_components_comparison_remove(inputs)
	if (locale === "pl") return pl_components_comparison_remove(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_remove(inputs)
	if (locale === "pt") return pt_components_comparison_remove(inputs)
	if (locale === "ro") return ro_components_comparison_remove(inputs)
	if (locale === "fi") return fi_components_comparison_remove(inputs)
	if (locale === "sv") return sv_components_comparison_remove(inputs)
	if (locale === "vi") return vi_components_comparison_remove(inputs)
	if (locale === "tr") return tr_components_comparison_remove(inputs)
	if (locale === "cs") return cs_components_comparison_remove(inputs)
	if (locale === "bg") return bg_components_comparison_remove(inputs)
	if (locale === "ru") return ru_components_comparison_remove(inputs)
	if (locale === "uk") return uk_components_comparison_remove(inputs)
	if (locale === "ar") return ar_components_comparison_remove(inputs)
	if (locale === "hi") return hi_components_comparison_remove(inputs)
	if (locale === "th") return th_components_comparison_remove(inputs)
	if (locale === "ja") return ja_components_comparison_remove(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_remove(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_remove(inputs)
	return ko_components_comparison_remove(inputs)
});
export { components_comparison_remove as "components.comparison.remove" }